export default function decimals (number, decimals) {
    number = number*1;
    return number.toFixed(decimals);
}